import React from "react";
import type { MaterialSymbol } from "material-symbols";
import { tokens } from "@blurb/codex-react";

export interface IconV3Props {
  icon: MaterialSymbol;
  size?: string | number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

// See developer integration guide for more info: https://developers.google.com/fonts/docs/material_symbols
// We are using a simple wrapper for importing & type-safety: https://www.npmjs.com/package/material-symbols
//
export const IconV3: React.FC<IconV3Props> = ({ icon, size = 24, color, className, style }) => {
  const finalColor = color || tokens.color.semantic.icon.bold;
  return (
    <span
      className={`material-symbols-rounded ${className || ""}`}
      style={{
        fontSize: size,
        color: finalColor,
        display: "inline-block",
        lineHeight: 1,
        ...style,
      }}
    >
      {icon}
    </span>
  );
};
